import { PPExpand } from 'processor-plataform-ui';
import React from 'react';
import ppicons from './ppicons.json';

const TabIcons: React.FC = () => {
    return (
        <div className='scrollable-v w100p' style={{ height: "calc(100% - 50px)" }}>

            <div className="tab-icons">
                {ppicons.map((icon, index) => (
                    <div key={index} className="icon">
                        <i className={icon} />
                        <span className="name">{icon}</span>
                    </div>
                ))}
            </div>

        </div>
    );
}

export default TabIcons;